module.exports = __webpack_public_path__ + "static/media/diploma.f4e3e78c.png";